import { colors } from 'vuetify/lib'

export default {
  themes: {
    light: {
      primary: '#3883D3',
      anchor: colors.blue.accent4,

      primaryBgr: '#3883D3',
      defaultBgr: '#FFFFFF',
      pRed: colors.red.base,
      pGreen: colors.lightGreen.darken1,
      pBlue: '#3883D3',
      pGrey: colors.grey.darken1,
      pYellow: '#F9A825'
    },
    dark: {
      primary: '#FFFFFF',
      anchor: colors.blue.lighten1,

      primaryBgr: '#363636',
      defaultBgr: '#272727',
      pRed: colors.red.lighten1,
      pGreen: colors.lightGreen.lighten1,
      pBlue: colors.blue.lighten1,
      pGrey: colors.grey.darken1,
      pYellow: '#F9A825'
    }
  }
}
